function updateSpanContent(span: HTMLSpanElement, content: string): void {
  if (content) {
    span.textContent = content;
    span.hidden = false;
  } else {
    span.textContent = "";
    span.hidden = true;
  }
}

function validateFormFieldName(name_value: string): string {
  if (!name_value) return "* Name is required";
  return null;
}

function validateFormFieldEmail(email_value: string): string {
  if (!email_value) {
    return "* Email is required";
  } else if (
    !/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(
      email_value,
    )
  ) {
    return "* Invalid email address";
  }
  return null;
}

function validateFormFieldPhone(phone_value: string): string {
  if (
    phone_value &&
    !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i.test(
      phone_value,
    )
  ) {
    return "* Invalid phone number";
  }
  return null;
}

function validateFormFieldSubject(subject_value: string): string {
  if (!subject_value) return "* Project description is required";
  return null;
}

const name_input = document.getElementById("name") as HTMLInputElement;
if (name_input) {
  const error_span = document.getElementById("nameError") as HTMLSpanElement;
  name_input.oninput = async (e) => {
    const name_input = e.currentTarget as HTMLInputElement;
    const error_message = validateFormFieldName(name_input.value);
    updateSpanContent(error_span, error_message);
  };
  name_input.addEventListener("focusout", name_input.oninput);
}

const email_input = document.getElementById("email") as HTMLInputElement;
if (email_input) {
  const error_span = document.getElementById("emailError") as HTMLElement;
  email_input.oninput = async (e) => {
    const email_input = e.currentTarget as HTMLInputElement;
    email_input.value = email_input.value.trim();
    const error_message = validateFormFieldEmail(email_input.value);
    updateSpanContent(error_span, error_message);
  };
  email_input.addEventListener("focusout", email_input.oninput);
}

const phone_input = document.getElementById("phone") as HTMLInputElement;
if (phone_input) {
  const error_span = document.getElementById("phoneError") as HTMLElement;
  phone_input.oninput = async (e) => {
    const phone_input = e.currentTarget as HTMLInputElement;
    phone_input.value = phone_input.value.trim();
    const error_message = validateFormFieldPhone(phone_input.value);
    updateSpanContent(error_span, error_message);
  };
  phone_input.addEventListener("focusout", phone_input.oninput);
}

const subject_input = document.getElementById("subject") as HTMLInputElement;
if (subject_input) {
  const error_span = document.getElementById("subjectError") as HTMLElement;
  subject_input.oninput = async (e) => {
    const subject_input = e.currentTarget as HTMLInputElement;
    const error_message = validateFormFieldSubject(subject_input.value);
    updateSpanContent(error_span, error_message);
  };
  subject_input.addEventListener("focusout", subject_input.oninput);
}

const form = document.getElementById("mainContactForm") as HTMLFormElement;
if (form) {
  const submit_btn = document.getElementById(
    "submitButton",
  ) as HTMLButtonElement;
  const submit_msg = document.getElementById(
    "formSubmitMessage",
  ) as HTMLSpanElement;

  form.onsubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const url = form.action;

    if (
      validateFormFieldName(name_input.value) ||
      validateFormFieldEmail(email_input.value) ||
      validateFormFieldPhone(phone_input.value) ||
      validateFormFieldSubject(subject_input.value)
    ) {
      name_input.dispatchEvent(new Event("input"));
      email_input.dispatchEvent(new Event("input"));
      phone_input.dispatchEvent(new Event("input"));
      subject_input.dispatchEvent(new Event("input"));
      updateSpanContent(
        submit_msg,
        "* Please fill all the required fields and try again",
      );
      submit_msg.classList.add("red");
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      console.log(response);
      submit_btn.classList.add("is_active");
      updateSpanContent(
        submit_msg,
        "Thank you for filling out the form! We will contact you soon!",
      );
      submit_msg.classList.add("green");
    } catch (error) {
      console.error(error);
      updateSpanContent(
        submit_msg,
        "Something went wrong... Please try again later",
      );
      submit_msg.classList.add("red");
    }
  };
}

const attachment_input = document.getElementById("inputAttachment");
if (attachment_input) {
  var label_html = attachment_input.getElementsByTagName(
    "label",
  )[0] as HTMLLabelElement;
  var icon = label_html.getElementsByTagName("img")[0] as HTMLImageElement;
  var label = label_html.getElementsByTagName("span")[0] as HTMLSpanElement;
  var input_html = attachment_input.getElementsByTagName(
    "input",
  )[0] as HTMLInputElement;

  const default_icon_src = structuredClone(icon.src);
  const default_label = structuredClone(label.innerHTML);

  input_html.addEventListener("change", () => {
    if (input_html.files && input_html.files.length > 0) {
      var file = input_html.files[0];

      icon.src = "/img/delete.svg";
      label.innerHTML = file.name;
    }
  });

  input_html.addEventListener("click", (e) => {
    if (input_html.files && input_html.files.length > 0) {
      input_html.value = "";

      icon.src = structuredClone(default_icon_src);
      label.innerHTML = structuredClone(default_label);

      e.preventDefault();
    }
  });
}
